var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniplayerDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.32,
    height: 28.319,
    viewBox: "0 0 28.32 28.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 28.32,
    height: 28.319,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M26.746,0h.829a1.141,1.141,0,0,1,.745,1.192q-.013,10.469,0,20.938a3.576,3.576,0,0,1-1.258,2.776,5.938,5.938,0,0,1-7.38.224,3.609,3.609,0,0,1-1.513-2.767,3.477,3.477,0,0,1,1.57-3.065,5.8,5.8,0,0,1,6.14-.516c.356.162.355.172.355-.222q0-5.456,0-10.911c0-.386-.044-.419-.406-.378q-2.357.27-4.715.534c-1.736.193-3.474.379-5.21.572-1.782.2-3.564.4-5.346.6-.4.044-.423.06-.423.472,0,4.862-.01,9.723.006,14.585a3.758,3.758,0,0,1-1.619,3.189,5.78,5.78,0,0,1-4.343,1.04A4.724,4.724,0,0,1,0,24.812V23.706a3.843,3.843,0,0,1,1.624-2.448,5.854,5.854,0,0,1,6.1-.439c.328.152.324.161.326-.2,0-.046,0-.092,0-.138q0-8.631,0-17.261A1.107,1.107,0,0,1,9.206,1.968c.888-.086,1.773-.192,2.659-.291q2.124-.238,4.248-.477,2.1-.234,4.194-.463Q22.46.5,24.611.256C25.323.175,26.034.086,26.746,0",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniplayerDefaultIcon);
export default __webpack_public_path__ + "static/media/miniplayerDefaultIcon.f28376fba3de2873abdbbe1911364be9.svg";
export { ForwardRef as ReactComponent };